import { useRef, useLayoutEffect } from 'react';

type Point = {
    x: number,
    y: number
};

function getScrollPosition(element: any): Point {
    return { x: element.scrollX, y: element.scrollY };
}

function setScrollPosition(element: any, position: Point) {
    element.scroll(position.x, position.y);
}

export default function useScrollPosition(element: any = window, deps?: [any], wait?: number) {
    const position = useRef(getScrollPosition(element));

    let throttleTimeout: NodeJS.Timeout | undefined;

    const onScroll = () => {
        position.current = getScrollPosition(element);
        throttleTimeout = undefined;
    }

    useLayoutEffect(() => {
        const handleScroll = () => {
            if (wait) {
                if (throttleTimeout === null) {
                    throttleTimeout = setTimeout(onScroll, wait);
                }
            } else {
                onScroll();
            }
        }

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, deps);

    const restoreScrollPosition = () => {
        setScrollPosition(element, position.current);
    };

    return {
        position,
        restoreScrollPosition
    };
}
